import camelize from 'underscore.string/camelize';

angular.module('filters').filter('camelize', function() {
  return function(data) {
    return camelize(data);
  };
});
